// extracted by mini-css-extract-plugin
module.exports = {"sizeAndFitWrapper":"FitToolAndSizeChart_sizeAndFitWrapper__QhWYK","sizeChartColumn":"FitToolAndSizeChart_sizeChartColumn__L3kf6"};